import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';
import { UmbracoLink } from '@models/umbraco.model';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { NgIf, NgClass } from '@angular/common';
import { LinkComponent } from '../routing/link/link.component';

@Component({
    selector: 'app-arrow-link',
    templateUrl: './arrow-link.component.html',
    styleUrls: ['./arrow-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LinkComponent, NgIf, NgClass, SvgIconComponent]
})
export class ArrowLinkComponent {
    @Output() linkClick = new EventEmitter<void>();

    @Input()
    public link: UmbracoLink;

    @Input()
    public queryParams?: Params | null;

    @Input()
    public arrowFirst = false;

    @Input()
    public direction: 'left' | 'right' = 'right';

    @Input()
    public cover = false;
}
